import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
} from "@chakra-ui/react";
import { Trans } from "@lingui/macro";

const OurWorkCompleted = () => (
  <Alert
    alignItems="top"
    gridTemplateColumns="max-content 1fr"
    display="grid"
    status="success"
    variant="top-accent"
  >
    <AlertIcon />
    <div>
      <AlertTitle>
        <Trans>Project progress is 100 %</Trans>
      </AlertTitle>
      <AlertDescription>
        <Trans>All budget items have progress set to 100 %</Trans>
      </AlertDescription>
    </div>
  </Alert>
);

export default OurWorkCompleted;
